import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {inAnteprima} from '../../skin';
import {impostazione} from '../../moduli/leggi';
import Nota from './Nota';
import {VincitaInFila, sezioniDaChiedere, useVincite} from './Vincite';
import './Vetrina.css';

/**
 * I BLOCCHI DELLA HOME CHE ASPETTANO IL BACKEND: Il tuo
 * vantaggio (jackpot, cashback istantaneo, missioni, ruota), Gara della
 * settimana. Sono disegnati come in Nova e si accendono dal backoffice
 * (Moduli › Home), ma i numeri non ci sono: li dara' il backend, con le API
 * scritte in docs/api-backend-nova.md. Finche' non ci sono, un blocco
 * acceso mostra LO SCHELETRO al posto dei numeri (barre vuote, riquadri
 * tratteggiati), mai cifre inventate: a chi gioca una cifra finta sembra
 * vera. In anteprima c'e' scritto perche'; sul sito vero una riga corta.
 *
 * Quando l'API ci sara', ogni blocco legge i suoi dati e riempie gli stessi
 * riquadri: la forma e' gia' questa.
 */

/* Una barra vuota al posto di un numero o di un testo che arrivera'. */
function Barra({larga, alta}) {
  return <span className={'vet-barra-vuota' + (larga ? ' larga' : '') + (alta ? ' alta' : '')} aria-hidden={'true'}/>;
}

/* La riga che dice perche' i numeri non ci sono: lunga in anteprima, corta per chi gioca. */
function Perche({blocco}) {
  const {t} = useTranslation();
  return (
    <Nota tono={'spento'} piccola giocatore={t('In arrivo.')}>
      {blocco.def.spento || t('Lo dà il backend: oggi l’API non c’è.')}
    </Nota>
  );
}

/**
 * VINCENDO ORA: la fila delle ultime vincite vere del sito (casino-service,
 * /public/casino/vincite?modo=recenti), riletta ogni 30 secondi. Finche' non
 * arrivano, o se il servizio non risponde, i riquadri vuoti di prima; senza
 * vincite nella settimana, una riga che lo dice. Mai vincite inventate.
 */
export function VincendoOra({blocco}) {
  const {t} = useTranslation();
  const titolo = impostazione(blocco, 'titolo') || t('Vincendo ora');
  const quante = Math.max(3, Math.min(12, Number(impostazione(blocco, 'quante')) || 8));
  const minimo = Number(impostazione(blocco, 'minimo')) || 0;
  const moltiplicatore = Number(impostazione(blocco, 'moltiplicatore')) || 0;
  const sezioni = sezioniDaChiedere();
  const {stato, dati} = useVincite(sezioni === null ? null : {modo: 'recenti', quante, sezione: sezioni,
    minimo: minimo > 0 ? minimo : undefined, moltiplicatore: moltiplicatore > 0 ? moltiplicatore : undefined}, 30000);
  const lista = stato === 'pronte' ? dati.vincite : null;
  return (
    <section className={'vet-blocco vet-vincendo' + (lista && lista.length ? '' : ' spento')} aria-label={titolo}>
      <div className={'vet-testata'}>
        <span className={'vet-pallino-live'} aria-hidden={'true'}/>
        <h2>{titolo}</h2>
        {inAnteprima() && !lista && <span className={'vet-etichetta'}>{t('in arrivo dal casinò')}</span>}
      </div>
      {stato === 'errore' && <Perche blocco={blocco}/>}
      {lista && lista.length === 0 && (
        <Nota tono={'spento'} piccola giocatore={t('Le prime vincite arrivano a breve.')}>
          {t('Nessuna vincita negli ultimi sette giorni con le soglie scritte qui: appena qualcuno vince, compare.')}
        </Nota>
      )}
      {lista && lista.length > 0 ? (
        <div className={'vet-vincite'} aria-label={t('Ultime vincite')}>
          {lista.map((v) => <VincitaInFila key={v.id} vincita={v}/>)}
        </div>
      ) : (
        <div className={'vet-vincite'} aria-hidden={'true'}>
          {Array.from({length: quante}, (_, i) => (
            <span key={i} className={'vet-vincita vuota'}>
              <span className={'vet-vincita-gioco'}/>
              <span className={'vet-vincita-testi'}><Barra/><Barra larga alta/><Barra/></span>
            </span>
          ))}
        </div>
      )}
    </section>
  );
}

/** IL TUO VANTAGGIO: jackpot, cashback istantaneo, missioni di oggi, ruota di oggi, ognuno col suo interruttore. */
export function Vantaggio({blocco}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const acceso = (k) => impostazione(blocco, k) !== false;
  const testo = (k) => String(impostazione(blocco, k) || '').trim();
  const ruotaA = testo('ruotaCollegamento');
  const vai = (dove) => { if (/^https?:\/\//i.test(dove)) window.open(dove, '_blank', 'noopener'); else navigate(dove); };
  const riquadri = [
    acceso('jackpot') && (
      <div key={'jackpot'} className={'vet-vantaggio-riquadro jackpot'}>
        <span className={'vet-vantaggio-titolo oro'}>★ {testo('jackpotTitolo') || t('Jackpot della rete')}</span>
        <Barra larga alta/>
        <span className={'vet-vantaggio-testo'}>{testo('jackpotTesto')}</span>
      </div>
    ),
    acceso('cashback') && (
      <div key={'cashback'} className={'vet-vantaggio-riquadro'}>
        <span className={'vet-vantaggio-titolo'}>{testo('cashbackTitolo') || t('Cashback istantaneo')}</span>
        <Barra alta/>
        <span className={'vet-vantaggio-testo'}>{testo('cashbackTesto')}</span>
        <button type={'button'} className={'vet-oro'} disabled>{testo('cashbackPulsante') || t('Riscuoti ora')}</button>
      </div>
    ),
    acceso('missioni') && (
      <div key={'missioni'} className={'vet-vantaggio-riquadro'}>
        <span className={'vet-vantaggio-titolo'}>{testo('missioniTitolo') || t('Missioni di oggi')}<span className={'oro'}>— / —</span></span>
        {[0, 1, 2].map((i) => (
          <span key={i} className={'vet-missione'} aria-hidden={'true'}>
            <span className={'vet-missione-riga'}><Barra larga/><Barra/></span>
            <span className={'vet-missione-barra'}><span style={{width: 0}}/></span>
          </span>
        ))}
      </div>
    ),
    acceso('ruota') && (
      <div key={'ruota'} className={'vet-vantaggio-riquadro ruota'}>
        <span className={'vet-vantaggio-ruota'} aria-hidden={'true'}/>
        <span className={'vet-vantaggio-titolo'}>{testo('ruotaTitolo') || t('Ruota di oggi')}</span>
        <span className={'vet-vantaggio-grande'}>{testo('ruotaTesto')}</span>
        {ruotaA && <button type={'button'} className={'vet-vantaggio-gira'} onClick={() => vai(ruotaA)}>{t('Gira')}</button>}
      </div>
    ),
  ].filter(Boolean);
  if (!riquadri.length) return null;
  return (
    <section className={'vet-blocco vet-vantaggio spento'} aria-label={t('Il tuo vantaggio')} style={{'--vet-vantaggio-quanti': riquadri.length}}>
      <Perche blocco={blocco}/>
      <div className={'vet-vantaggio-riquadri'}>{riquadri}</div>
    </section>
  );
}

/** GARA DELLA SETTIMANA: nome, montepremi, scadenza, i primi in classifica (vuoti) e «Classifica completa». */
export function Gara({blocco}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const testo = (k) => String(impostazione(blocco, k) || '').trim();
  const dove = testo('collegamento');
  return (
    <section className={'vet-blocco vet-gara spento'} aria-label={testo('titolo') || t('Gara della settimana')}>
      <Perche blocco={blocco}/>
      <div className={'vet-gara-striscia'}>
        <span className={'vet-gara-testi'}>
          <span className={'vet-vantaggio-titolo'}>{testo('titolo') || t('Gara della settimana')}</span>
          {testo('premio') && <span className={'vet-gara-premio'}>{testo('premio')}</span>}
          {testo('scadenza') && <span className={'vet-vantaggio-testo'}>{testo('scadenza')}</span>}
        </span>
        <span className={'vet-gara-primi'} aria-hidden={'true'}>
          {[1, 2, 3, 4, 5].map((n) => <span key={n} className={'vet-gara-primo'}><i>{n}</i><Barra/><Barra/></span>)}
        </span>
        {dove && <button type={'button'} className={'vet-gara-tutta'} onClick={() => navigate(dove)}>{t('Classifica completa')}</button>}
      </div>
    </section>
  );
}

/**
 * SCRIVICI (pagina Assistenza, modulo Aiuto › Assistenza › Scrivici): il
 * modulo per scrivere all'assistenza. Il backend che riceve i messaggi
 * (ticket) non c'e' ancora: i campi si vedono, «Invia» resta spento e c'e'
 * scritto perche'. Quando l'API ci sara', «Invia» manda il messaggio e
 * mostra il numero del ticket.
 */
export function Scrivici() {
  const {t} = useTranslation();
  return (
    <form className={'vet-scrivici'} aria-label={t('Scrivici')} onSubmit={(e) => e.preventDefault()}>
      <h3>{t('Scrivici')}</h3>
      <div className={'vet-scrivici-campi'}>
        <label><span>{t('Nome utente o e-mail')}</span><input type={'text'} disabled/></label>
        <label><span>{t('Argomento')}</span><input type={'text'} disabled placeholder={t('Prelievo, bonus, conto…')}/></label>
      </div>
      <label><span>{t('Messaggio')}</span><textarea rows={4} disabled placeholder={t('Raccontaci cosa succede')}/></label>
      <div className={'vet-scrivici-piede'}>
        <Nota tono={'spento'} piccola giocatore={t('Il modulo arriva a breve: intanto scrivici via e-mail.')}>
          {t('I messaggi li riceve il backend (API dei ticket, docs/api-backend-nova.md): finché non c’è, «Invia» resta spento.')}
        </Nota>
        <button type={'submit'} className={'vet-oro'} disabled>{t('Invia')}</button>
      </div>
    </form>
  );
}
